<template>
  <MapToolbarTooltipBlock
    caption-spacing="relaxed"
    icon-area-size="sm"
    :block-class="blockClass"
    :caption="captionDisplay"
    :tooltip-text="tooltipDisplay"
    :active="active"
    :active-variant="activeVariant"
    :btn-class="btnClass"
    :btn-props="toolbarBtnProps"
    v-on="btnListeners"
  >
    <v-icon :color="iconColor">{{ active ? (iconActive || icon) : (iconInactive || icon) }}</v-icon>
  </MapToolbarTooltipBlock>
</template>

<script>
import MapToolbarTooltipBlock from './MapToolbarTooltipBlock.vue';
import {
  mapToolbarInteractiveBtnProps,
  mapToolbarPressedToggleBtnProps,
  mapToolbarToggleIconColor
} from '@/utils/mapToolbarTheme';

/**
 * 지도 툴바 공통 토글 버튼
 *
 * active/inactive 상태에 따라 아이콘·캡션·툴팁 전환.
 * 다크모드/라이트모드 대응은 MapToolbarTooltipBlock · mapToolbarTheme 이 처리.
 */
export default {
  name: 'MapToggleBtn',
  components: { MapToolbarTooltipBlock },
  props: {
    caption: { type: String, default: '' },
    captionInactive: { type: String, default: '' },
    tooltip: { type: String, default: '' },
    tooltipInactive: { type: String, default: '' },
    active: { type: Boolean, default: false },
    icon: { type: String, default: '' },
    iconActive: { type: String, default: '' },
    iconInactive: { type: String, default: '' },
    blockClass: { type: String, default: 'toolbarmap_color' },
    btnClass: { type: [String, Object, Array], default: null },
    /** primary: 보라 채움+흰 캡션(눌림) / subtle: 연보라·슬레이트 */
    activeVariant: {
      type: String,
      default: 'primary',
      validator: (v) => ['primary', 'subtle'].includes(v)
    }
  },
  computed: {
    captionDisplay() {
      if (this.active) return this.caption || this.captionInactive;
      return this.captionInactive || this.caption;
    },
    tooltipDisplay() {
      if (this.active) return this.tooltip || this.tooltipInactive;
      return this.tooltipInactive || this.tooltip;
    },
    toolbarBtnProps() {
      if (this.activeVariant === 'subtle') {
        return mapToolbarInteractiveBtnProps(this.$vuetify, {
          active: this.active,
          variant: 'subtle',
          extra: { small: true, elevation: this.active ? 0 : 1 }
        });
      }
      return mapToolbarPressedToggleBtnProps(this.$vuetify, {
        active: this.active,
        extra: { small: true }
      });
    },
    iconColor() {
      if (this.activeVariant === 'primary' && this.active) {
        return 'mapToolIconOnPrimary';
      }
      return mapToolbarToggleIconColor(this.$vuetify, this.active);
    },
    btnListeners() {
      const listeners = { ...this.$listeners };
      const userClick = listeners.click;
      listeners.click = (event) => {
        this.$emit('toggle');
        if (typeof userClick === 'function') userClick(event);
      };
      return listeners;
    }
  }
};
</script>
